import "react-perfect-scrollbar/dist/css/styles.css";
import GlobalStyles from "src/layouts/GlobalStyles";
import { useRoutes } from "react-router-dom";
import { ThemeProvider } from "@material-ui/core";
import { Provider } from "react-redux";
import theme from "src/theme";
import routes from "src/routes";
import store from "src/store";
import { createBrowserHistory } from "history";

import {
  responseInterceptor,
  requestInterceptor,
} from "src/services/http/interceptors";
import { ThemeProvider as StyledThemeProvider } from "styled-components";

const browserHistory = createBrowserHistory();
responseInterceptor(store);
requestInterceptor(store, browserHistory);

const App = () => {
  const routing = useRoutes(routes);

  return (
    <Provider store={store}>
      <StyledThemeProvider theme={theme}>
        <ThemeProvider theme={theme}>
          <GlobalStyles />
          {routing}
        </ThemeProvider>
      </StyledThemeProvider>
    </Provider>
  );
};

export default App;
